// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ikVRL","col":"styles_col__3BKhV"};